import React from 'react';
import { Grid } from '../../../../../../ui/grid/Grid';
import styles from './TwoColumnGrid.module.scss';

type Props = {
    left: React.ReactNode;
    right: React.ReactNode;
    commonCta?: React.ReactNode;
};

const TwoColumnGrid = ({ left, right, commonCta }: Props) => {
    return (
        <div className={styles['two-column-grid']}>
            <Grid.Wrapper type='rows'>
                <Grid.Element type='row' grow>
                    <Grid.Wrapper type='cols' arrange='2-2' width='md' gap scroll>
                        {left && <Grid.Element type='col'>
                            {left}
                        </Grid.Element>}

                        {right && left && <Grid.Element type='sep' padding />}

                        {right && <Grid.Element type='col'>
                            {right}
                        </Grid.Element>}
                    </Grid.Wrapper>
                </Grid.Element>

                {commonCta && <>
                    <Grid.Element type='sep' padding />
                    <Grid.Element type='row' padding>
                        <div className={styles.actionsRow}>
                            {commonCta}
                        </div>
                    </Grid.Element>
                </>}
            </Grid.Wrapper>
        </div>
    );
};

export default TwoColumnGrid;
